parseTokenTimezoneHHMM